import React from "react";
import {
  BonusDrawContainer,
  BonusDrawContent,
  BonusDrawHeader,
  BonusDrawImage,
  BonusDrawInfo,
  BonusDrawMedia,
  BonusDrawbadge,
  Button,
  SubtitleText,
  TitleText,
} from "raffle-house-uikit";

import "./style.scss";

export default function BonusDraw({ onCTAClick, bonusDraw, image, videoData }) {
  const generetePriceForBadge = () => {
    const price = bonusDraw.price || "";
    const num = parseInt(price.replace(/,/g, ""), 10);
    const thousands = Math.round(num / 1000);
    return `£${thousands}k`;
  };

  const poster = videoData && videoData.videoPreviewUrl && videoData.videoPreviewUrl.length ? videoData.videoPreviewUrl : null;
  const video = videoData && videoData.videoUrl && videoData.videoUrl.length ? videoData.videoUrl : null;
  // const poster =
  //   "https://raffle-house-production.s3.eu-west-1.amazonaws.com/bonus-draw/video/01.11.2025/eb-preview.jpg";
  // const video =
  //   "https://raffle-house-production.s3.eu-west-1.amazonaws.com/bonus-draw/video/01.11.2025/eb.mp4";

  return (
    <BonusDrawContainer>
      <BonusDrawHeader>
        <TitleText isCentered as="h2" variant={"primary"} color="color-1">
          The {bonusDraw.profileTitle} Early Bird Draw
        </TitleText>
        <SubtitleText color="color-1" isCentered>
          {bonusDraw.metaDescription}
        </SubtitleText>
      </BonusDrawHeader>
      <BonusDrawContent>
        <BonusDrawInfo>
          <TitleText isCentered as="h3" variant={"primary"} color="color-2">
            {bonusDraw.metaTitle}
          </TitleText>
          <Button onClick={onCTAClick}>Enter now</Button>
        </BonusDrawInfo>
        <BonusDrawMedia>
          {video ? (
            <video
              id="early-bird-draw-video"
              loop
              autoPlay={true}
              muted
              playsInline
              data-wf-ignore="true"
              data-object-fit="cover"
              poster={poster}
            >
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <BonusDrawImage
              srcSet={`
              ${image.image800Url} 800w,
              ${image.image1600Url} 1600w,
              ${image.image2048Url} 2048w,
              ${image.image3840Url} 3840w,
            `}
              sizes={`(max-width: 800px) 800px, (max-width: 1600px) 1600px, (max-width: 2048px) 2048px, 3840px`}
              src={image.image1600Url}
              alt={`The ${bonusDraw.profileTitle} Bonus Draw`}
            />
          )}
          <BonusDrawbadge price={generetePriceForBadge()} />
        </BonusDrawMedia>
      </BonusDrawContent>
    </BonusDrawContainer>
  );
}
